// 白色梯度
export const White = {
  "white-1": "#D4E7FF",
  "white-2": "#DAE6FB",
  "white-3": "#DFEDFF",
  "white-4": "#E5F3FE",
  "white-5": "#EDF5FF",
  "white-6": "#F1F9FF",
  "white-7": "#F6FAFF",
  "white-8": "#F9FBFF",
  "white-9": "#F5F9FF",
  "white-10": "#FFFFFF",
  "white-11": "#F2F7FC",
} as const;

// 黑色梯度
export const Black = {
  "black-1": "#1C1E20",
  "black-2": "#212429",
  "black-3": "#252933",
  "black-4": "#292D36",
  "black-5": "#2D3039",
  "black-6": "#333741",
  "black-7": "#3B3F49",
  "black-8": "#444955",
  "black-9": "#535A66",
  "black-10": "#586571",
  "black-11": "#465669",
} as const;

// 灰色
export const Gray = {
  "gray-1": "#506265",
  "gray-2": "#688199",
  "gray-3": "#8C9CA6",
};

// 蓝色
export const Blue = {
  "blue-1": "#1C3664",
  "blue-2": "#2C3A85",
  "blue-3": "#244E8D",
  "blue-4": "#354A98",
  "blue-5": "#3D72EB",
  "blue-6": "#3C7BEA",
  "blue-7": "#487FD0",
  "blue-8": "#2C99FD",
  "blue-9": "#509FFF",
  "blue-10": "#4C9EFE",
  "blue-11": "#6791FF",
  "blue-12": "rgba(61, 114, 235, 0.3)",
  "blue-13": "rgba(76, 158, 254, 0.2)",
};

export default {
  ...White,
  ...Black,
  ...Blue,
};
